export enum ArgumentType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  PROPERTY_MAP = 'PROPERTY_MAP',
}
